import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { NavigateBefore } from "@mui/icons-material";

export default function ButtonGoBack({ goBack = -1, ...props }) {
  const navigate = useNavigate();
  return (
    <Button
      sx={{
        width: "100px",
        height: "25px",
        padding: "6px 12px",
        borderRadius: "5px",
        border: "1px solid #1E729F",
        gap: "6px",
        textTransform: "math-auto",
        fontSize: "16px",
        lineHeight: "22px",
        fontFamily: "Nunito",
        fontWeight: 500,
        marginBottom: "16px",
      }}
      onClick={() => navigate(goBack)}
      variant="outlined"
      {...props}
    >
      <NavigateBefore /> Voltar
    </Button>
  );
}
